export const searchRegexString = search => `(${(search || '').replace(/[^\w-\s]/g, '.').split(/\s+/g).join(' ')})`;

export const searchRegex = search => new RegExp(searchRegexString(search), 'i');

export const searchQuery = (search, service = 'users') => {
  const searchObj = search && { $regex: searchRegexString(search), $options: 'i' };
  let query;
  switch (service) {
    case 'users':
      query = {
        $sort: { 'profile.firstname': 1, 'profile.lastname': 1 },
        ...(search ? {
          $or: [
            { 'profile.firstname': searchObj },
            { 'profile.lastname': searchObj },
            { 'profile.displayname': searchObj },
            { username: searchObj },
          ],
        } : {}),
      };
      break;
    case 'units':
      query = {
        $sort: { year: -1, name: 1 },
        ...(search ? {
          $or: [
            { name: searchObj },
            { unitcode: searchObj },
          ],
        } : {}),
      };
      break;
    default:
      query = {
        $sort: { name: 1 },
        ...(search ? {
          name: searchObj,
        } : {}),
      };
  }
  return query;
};
